import { ArquivarSolicitacao } from './ArquivarSolicVistoria';

export default ArquivarSolicitacao;